import type { SVGProps } from 'react'

interface DropIconProps extends SVGProps<SVGSVGElement> {}

export function DropIcon(props: DropIconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_645_1120)">
        <path
          d="M2.54926 18.4339C3.02443 19.0279 3.22971 19.2357 3.66695 19.2357C4.10419 19.2357 4.30946 19.0279 4.78481 18.4339C5.28784 17.8052 5.97668 16.9441 7.33406 16.9441C8.69127 16.9441 9.38011 17.8052 9.88315 18.4339C10.3582 19.0279 10.5636 19.2357 11.0005 19.2357C11.4376 19.2357 11.6429 19.0279 12.118 18.4339C12.6211 17.8052 13.3099 16.9441 14.6671 16.9441C16.0243 16.9441 16.7132 17.8052 17.2162 18.4339C17.6912 19.0279 17.8965 19.2357 18.3336 19.2357C18.7706 19.2357 18.9757 19.0279 19.4509 18.4341C19.9539 17.8052 20.6428 16.9441 22 16.9441V18.7775C21.5629 18.7775 21.3578 18.9853 20.8826 19.5793C20.3796 20.2081 19.6908 21.0691 18.3336 21.0691C16.9763 21.0691 16.2875 20.2081 15.7845 19.5793C15.3095 18.9853 15.1042 18.7775 14.6671 18.7775C14.23 18.7775 14.0248 18.9853 13.5496 19.5793C13.0466 20.2081 12.3579 21.0691 11.0005 21.0691C9.6433 21.0691 8.95445 20.2081 8.45142 19.5793C7.97641 18.9853 7.77097 18.7775 7.33406 18.7775C6.89682 18.7775 6.69154 18.9853 6.2162 19.5793C5.71317 20.2081 5.02432 21.0691 3.66695 21.0691C2.30974 21.0691 1.62073 20.2081 1.11769 19.5793C0.642517 18.9853 0.437241 18.7775 0 18.7775V16.9441C1.35738 16.9441 2.04622 17.8052 2.54926 18.4339Z"
          fill="currentColor"
        />
        <path
          d="M11.0004 16.4857C7.46234 16.4857 4.58377 13.6072 4.58377 10.0691C4.58377 6.73367 9.77762 1.71505 10.3698 1.15377C10.7234 0.818584 11.2773 0.818584 11.631 1.15377C12.2231 1.71505 17.417 6.73367 17.417 10.0691C17.417 13.6073 14.5384 16.4857 11.0004 16.4857ZM11.0002 3.10398C9.0119 5.121 6.41699 8.33442 6.41699 10.0691C6.41699 12.5964 8.47311 14.6525 11.0004 14.6525C13.5276 14.6525 15.5838 12.5964 15.5838 10.0691C15.5838 8.33711 12.9885 5.12234 11.0002 3.10398Z"
          fill="currentColor"
        />
        <path
          d="M12.3753 10.0691H11.8382L13.0235 11.2543L11.7272 12.5506L8.9772 9.80057C8.71503 9.53839 8.63648 9.14412 8.77847 8.80154C8.92047 8.45914 9.25449 8.23573 9.62526 8.23573H10.1624L8.9772 7.05057L10.2735 5.75429L13.0235 8.50429C13.2857 8.76646 13.364 9.16074 13.2222 9.50331C13.0802 9.84572 12.746 10.0691 12.3753 10.0691Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_645_1120">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="matrix(-1 0 0 1 22 0)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
